export const getCapitalized = (text: string) =>
  text.charAt(0).toUpperCase() + text.substr(1);
